import React, { Fragment, useState, useEffect } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';



function PDFUpladUnilav({ onFileChange, onTypeChange }) {
  const UnilavPdfFormat = [
    { name: 'nazionale', label: 'Nazionale' },
    { name: 'lombardia', label: 'Lombardia' },
    { name: 'sintesi', label: 'Sintesi' },
    { name: 'sare', label: 'Sare' },
    { name: 'sardegna', label: 'Sardegna' },
    { name: 'veneto', label: 'Veneto' },
    { name: 'toscana', label: 'Toscana' },
  ];

  const [selected, setSelected] = useState(UnilavPdfFormat[0]);

  useEffect(() => {
    onTypeChange(UnilavPdfFormat[0].name);
  }, []);

  const handleUploadFile = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      onFileChange(event.target.files[0]);
    }
  };

  const handleTypeChange = (selectedOption) => {
    setSelected(selectedOption);
    onTypeChange(selectedOption.name);
  };

  function capitalizeFirstLetter(str) {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }


  return (
    <div className="w-full">
      <h3 className='text-sm text-gray-700 mb-2'>Seleziona Formato Unilav</h3>
      <Combobox value={selected} onChange={handleTypeChange}>
        <div className="relative mt-1">
          <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-indigo-300 sm:text-sm">
            <Combobox.Input
              className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
              displayValue={(option) => option.label}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => {}}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
              {UnilavPdfFormat.length === 0 ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                UnilavPdfFormat.map((option) => (
                  <Combobox.Option
                    key={option.name}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? 'bg-indigo-200 bg-opacity-50 text-gray-900' : 'text-gray-900'
                      }`
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? 'font-medium' : 'font-normal'
                          }`}
                        >
                          {capitalizeFirstLetter(option.name)}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? 'text-gray-500' : 'text-indigo-600'
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>

      <form className="flex items-center space-x-6 border border-2-gray rounded-md shadow-md mt-5">
        <div className="grid grid-cols-1 w-full">
          <div className='col-span-1 w-full'>
            <label className="block">
              <input
                type="file"
                className="block file:py-6 w-full text-sm text-slate-500
                  file:mr-4 file:px-4
                  file:rounded-75 file:border-0
                  file:text-sm file:font-semibold
                  file:bg-indigo-50 file:text-indigo-700
                  hover:file:bg-indigo-100
                "
                onChange={handleUploadFile}
              />
            </label>
          </div>
        </div>
      </form>
    </div>
  );
}

export default PDFUpladUnilav;
